<template>
  <ihreVorteile></ihreVorteile>
  <energieAusweis></energieAusweis>
  <foerdermittelBeratung></foerdermittelBeratung>
  <neubauBegleitung></neubauBegleitung>
  <bauBegleitung></bauBegleitung>
  <contactSection></contactSection>
</template>

<script>
import bauBegleitung from "@/components/bauBegleitung.vue";
import foerdermittelBeratung from "@/components/foerdermittelBeratung.vue";
import neubauBegleitung from "@/components/neubauBegleitung.vue";
import energieAusweis from "@/components/energieAusweis.vue";
import contactSection from "@/components/contactSection.vue";
import ihreVorteile from "@/components/ihreVorteile.vue";
import { useHead } from '@vueuse/head';
import lang from "@/lang/lang";

export default {
  setup() {
    useHead({
      title: 'DM‑Energieberatung – Energieeffizienz & Nachhaltigkeit',
      link: [
        {rel: 'canonical', href: 'https://www.dm-energieberatung.de/'}
      ],
      meta: [
        {property: 'og:title', content: 'DM‑Energieberatung – Energieeffizienz & Nachhaltigkeit'},
        {
          property: 'og:description',
          content: 'DM‑Energieberatung begleitet Sie zu mehr Energieeffizienz, Fördermöglichkeiten & Mängelbeseitigung bei Sanierung, Neubau oder Umbau.'
        },
        {property: 'og:type', content: 'website'},
        {property: 'og:url', content: 'https://www.dm-energieberatung.de/'},
        {property: 'og:image', content: 'https://www.dm-energieberatung.de/images/topSection/topSection.webp'},
        {property: 'og:locale', content: 'de_DE'},
        {property: 'og:site_name', content: 'DM‑Energieberatung'}
      ],
      script: [
        {
          type: 'application/ld+json',
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "DM‑Energieberatung",
            "url": "https://www.dm-energieberatung.de/",
            "logo": "https://www.dm-energieberatung.de/images/core/logo.png",
            "image": "https://www.dm-energieberatung.de/images/core/logo.png",
            "description": "DM‑Energieberatung begleitet Sie zu mehr Energieeffizienz, Fördermöglichkeiten & Mängelbeseitigung bei Sanierung, Neubau oder Umbau.",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": lang.impressum.address,
              "addressLocality": lang.impressum.city,
              "postalCode": lang.impressum.plz,
              "addressCountry": lang.impressum.country_short
            },
            "email": lang.impressum.email_content,
            "phone": lang.impressum.phone
          })
        }
      ]
    })
  },
  components: {
    ihreVorteile,
    energieAusweis,
    foerdermittelBeratung,
    neubauBegleitung,
    bauBegleitung,
    contactSection
  }
}
</script>
